"use client";

import { Download, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogClose, DialogContent } from "@/components/ui/dialog";

interface ImageModalProps {
  src: string;
  alt: string;
  isOpen: boolean;
  onClose: () => void;
}

export function ImageModal({ src, alt, isOpen, onClose }: ImageModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-h-[95vh] max-w-[95vw] gap-0 overflow-hidden p-0">
        <div className="relative flex size-full flex-col">
          {/* Header with close and download buttons */}
          <div className="absolute right-0 top-0 z-10 flex gap-2 p-4">
            <Button variant="secondary" size="icon" asChild>
              <a href={src} download>
                <Download className="size-4" />
              </a>
            </Button>
            <DialogClose asChild>
              <Button variant="secondary" size="icon">
                <X className="size-4" />
              </Button>
            </DialogClose>
          </div>

          {/* Full-size image */}
          <div className="max-h-[95vh] flex-1 overflow-y-auto p-4">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={src}
              alt={alt}
              className="mx-auto h-auto max-w-full object-contain"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
